import { Box, styled } from '@mui/material';

const Mark = styled(Box)`
  min-width: 15px;
  height: 15px;
  text-align: center;
  font-size: 10px;
  line-height: 15px;
  border-radius: 8px;
  color: white;

  background-color: ${({ color }) => color};
`;

export default Mark;
